<template lang="pug">
section.src-components-cajas-toolbar
  v-btn.ma-3(small @click="db_update()" color="secondary" dark) #[v-icon mdi-update] Actualizar 
</template>

<script lang="js">
  import { EventBus } from '@/event-bus';
  export default  {
    name: 'src-components-cajas-toolbar',
    props: [],
    mounted () {

    },
    data () {
      return {

      }
    },
    methods: {
      changeDB(micomercio) {
        this.$store.commit('micomercio',micomercio)
        EventBus.$emit('toolbar_click','update');
      },
      db_update() {
        EventBus.$emit('toolbar_click','update');
      }
    },
    computed: {

    }
}


</script>

<style scoped lang="scss">
  .src-components-cajas-toolbar {

  }
</style>
